<template>
  <div class="flex flex-col bg-white px-2">
    <div class="flex flex-col gap-[5px] pt-3 mt-3">
      <db-form class="flex flex-col gap-[5px]">
        <p class="flex justify-center mt-2 text-sm'">
          {{ $t("landing.reset_password.code_info") }}
        </p>
        <db-input
          variant="outline"
          :placeholder="$t('landing.reset_password.code') + '*'"
          :label="$t('landing.reset_password.code') + '*'"
          name="code"
          :ariainvalid="errors.code ? 'true' : ''"
          v-model="user.code"
        ></db-input>
        <p
          :class="
            errors.code == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          "
        >
          {{ $t("landing.reset_password.error_reset_password") }}
        </p>
        <db-button
          id="login"
          variant="brand-primary"
          class-list="w-full mt-2"
          @click="reset"
        >
          {{ $t("landing.reset_password.confirm") }}
        </db-button>

        <db-button
          id="login"
          variant="tertiary-plain"
          class-list="w-full mt-2"
          @click="() => router.push('/reset-password-guest')"
        >
          {{ $t("landing.reset_password.not_recieved") }}
        </db-button>
      </db-form>
      <div class="flex w-full pt-16">
        <p class="text-sm text-gray-400">
          {{ $t("landing.required_field") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import DbInput from "@/components/DB-Components/DbInput.vue";
import DbButton from "@/components/DB-Components/DbButton.vue";
import router from "@/router";

export default defineComponent({
  components: { DbInput, DbButton },
  name: "LoginComponent",

  setup() {
    const router = useRouter();
    const title = process.env.NODE_ENV;
    const user = ref({
      username: "",
      code: "",
    });

    const errors = ref({
      username: false,
      code: false,
    });

    const resetErrors = () => {
      errors.value = {
        username: false,
        code: false,
      };
    };

    const reset = async () => {
      await store.dispatch("toggleLoading", true);
      resetErrors();
      try {
        const result = await window.confirmationResult.confirm(
          user.value?.code
        );
        const idToken = await result.user.getIdToken(); // 🔥 Secure token
        await store
          .dispatch("UserStore/resetByCode", { code: idToken })
          .then(async (res) => {
            const token = res.data?.token;

            if (token) {
              await store.dispatch("UserStore/setUser", res.data);
              router.push(`/reset-password-link/${token}`);
            } else {
              console.warn("Missing token in response");
              errors.value = {
                username: true,
                code: true,
              };
            }
          })
          .catch((error) => {
            errors.value = {
              username: true,
              code: true,
            };
          })
          .finally(() => {
            store.dispatch("toggleLoading", false);
          });
      } catch (e) {
        await store.dispatch("toggleLoading", false);
        console.error("Code invalid");
        errors.value = {
          username: true,
          code: true,
        };
        return;
      }
    };

    return {
      user,
      reset,
      title,
      errors,
      router,
    };
  },
});
</script>
